/* ============================================================
   OLFYN — motion engine (dependency-free)
   Reveals · hero 3D tilt · header · scent-ribbon canvas
   ============================================================ */
(function(){
  "use strict";
  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var fine   = window.matchMedia("(pointer: fine)").matches;

  /* ---------- scroll reveals ---------- */
  function initReveals(){
    var targets = document.querySelectorAll(".reveal,.lines,[data-io]");
    if(!("IntersectionObserver" in window) || reduce){
      targets.forEach(function(t){ t.classList.add("is-in"); });
      return;
    }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(e.isIntersecting){ e.target.classList.add("is-in"); io.unobserve(e.target); }
      });
    },{ threshold:0.15, rootMargin:"0px 0px -8% 0px" });
    targets.forEach(function(t){ io.observe(t); });
  }

  /* ---------- header: hide on scroll-down, solidify past hero ---------- */
  function initHeader(){
    var header = document.querySelector(".site-header");
    if(!header) return;
    var last = 0, ticking = false;
    function update(){
      var y = window.pageYOffset;
      header.classList.toggle("solid", y > window.innerHeight * 0.6);
      if(y > last && y > 400){ header.classList.add("hide"); }
      else { header.classList.remove("hide"); }
      last = y; ticking = false;
    }
    window.addEventListener("scroll", function(){
      if(!ticking){ requestAnimationFrame(update); ticking = true; }
    }, { passive:true });
  }

  /* ---------- hero 3D tilt + parallax ---------- */
  function initHero(){
    var media = document.querySelector(".hero__media");
    var glow  = document.querySelector(".hero__glow");
    if(!media || reduce || !fine) return;
    var tx=0,ty=0,cx=0,cy=0;
    window.addEventListener("mousemove", function(e){
      var nx = (e.clientX / window.innerWidth  - .5);
      var ny = (e.clientY / window.innerHeight - .5);
      tx = nx; ty = ny;
    }, { passive:true });
    (function loop(){
      cx += (tx - cx) * .06; cy += (ty - cy) * .06;
      media.style.transform =
        "rotateY(" + (cx*14).toFixed(2) + "deg) rotateX(" + (-cy*12).toFixed(2) +
        "deg) translateZ(0)";
      if(glow) glow.style.transform = "translate3d(" + (cx*40) + "px," + (cy*40) + "px,-200px)";
      requestAnimationFrame(loop);
    })();
  }

  /* ---------- hero video: play only while visible ---------- */
  function initVideo(){
    var v = document.querySelector(".hero-cine__video") || document.querySelector(".hero__media video");
    if(!v) return;
    if(reduce) return; /* respect prefers-reduced-motion: leave the poster frame, no autoplay */
    var p = v.play(); if(p && p.catch) p.catch(function(){});
    if("IntersectionObserver" in window){
      new IntersectionObserver(function(es){
        es.forEach(function(e){ e.isIntersecting ? v.play().catch(function(){}) : v.pause(); });
      },{threshold:.1}).observe(v);
    }
  }

  /* ---------- scent ribbon: additive-blended vapor trail ---------- */
  function initRibbon(){
    var c = document.getElementById("ribbon");
    if(!c || reduce) return;
    var ctx = c.getContext("2d"), DPR = Math.min(window.devicePixelRatio||1, 2);
    var w,h; function size(){ w=c.width=innerWidth*DPR; h=c.height=innerHeight*DPR;
      c.style.width=innerWidth+"px"; c.style.height=innerHeight+"px"; }
    size(); addEventListener("resize", size, {passive:true});

    // a chain of nodes that trails toward a moving anchor (cursor / drifting)
    var N = 26, nodes = [], mx = innerWidth*DPR*.5, my = innerHeight*DPR*.5, drift = 0;
    for(var i=0;i<N;i++) nodes.push({x:mx,y:my});
    if(fine) addEventListener("mousemove", function(e){
      mx = e.clientX*DPR; my = e.clientY*DPR;
    }, {passive:true});

    function frame(){
      drift += .008;
      if(!fine){ // ambient auto-drift on touch devices
        mx = w*(.5 + Math.sin(drift)*.28);
        my = h*(.45 + Math.cos(drift*1.3)*.22);
      }
      ctx.clearRect(0,0,w,h);
      var px = mx, py = my;
      nodes[0].x += (px-nodes[0].x)*.22; nodes[0].y += (py-nodes[0].y)*.22;
      for(var i=1;i<N;i++){
        nodes[i].x += (nodes[i-1].x-nodes[i].x)*.28;
        nodes[i].y += (nodes[i-1].y-nodes[i].y)*.28;
      }
      ctx.globalCompositeOperation = "source-over";
      for(var j=1;j<N;j++){
        var t = j/N, wob = Math.sin(drift*3 + j*.6)*8*DPR;
        ctx.beginPath();
        ctx.moveTo(nodes[j-1].x, nodes[j-1].y+wob);
        ctx.lineTo(nodes[j].x,   nodes[j].y+wob);
        ctx.strokeStyle = "rgba(150,112,46," + (0.16*(1-t)) + ")";
        ctx.lineWidth = (1-t)*10*DPR;
        ctx.lineCap = "round";
        ctx.stroke();
      }
      requestAnimationFrame(frame);
    }
    frame();
  }

  /* ---------- collections: expand hovered panel on desktop ---------- */
  function initCollections(){
    if(!fine) return;
    document.querySelectorAll(".collections__grid").forEach(function(grid){
      var fams = grid.querySelectorAll(".fam");
      fams.forEach(function(f){
        f.addEventListener("mouseenter", function(){
          fams.forEach(function(x){ x.style.flexGrow = (x===f)?"1.6":"1"; });
        });
      });
      grid.addEventListener("mouseleave", function(){
        fams.forEach(function(x){ x.style.flexGrow = "1"; });
      });
    });
  }

  /* ---------- mobile drawer ---------- */
  function initDrawer(){
    var toggle = document.querySelector("[data-nav-toggle]");
    var drawer = document.querySelector("[data-drawer]");
    if(!toggle || !drawer) return;
    var closeBtn = drawer.querySelector("[data-drawer-close]");
    function open(){ drawer.hidden = false; requestAnimationFrame(function(){ drawer.classList.add("open"); });
      toggle.setAttribute("aria-expanded","true"); document.body.style.overflow = "hidden"; }
    function close(){ drawer.classList.remove("open"); toggle.setAttribute("aria-expanded","false");
      document.body.style.overflow = ""; setTimeout(function(){ drawer.hidden = true; }, 500); }
    toggle.addEventListener("click", open);
    if(closeBtn) closeBtn.addEventListener("click", close);
    drawer.addEventListener("click", function(e){ if(e.target === drawer) close(); });
    document.addEventListener("keydown", function(e){ if(e.key === "Escape" && drawer.classList.contains("open")) close(); });
  }

  /* ---------- ajax add-to-cart (updates count, no full reload) ---------- */
  function initCart(){
    var counts = document.querySelectorAll("[data-cart-count]");
    document.querySelectorAll(".pcard__form").forEach(function(form){
      form.addEventListener("submit", function(e){
        e.preventDefault();
        var btn = form.querySelector("button");
        var label = btn.textContent;
        var vid = (form.querySelector("[name=id]") || {}).value;
        btn.textContent = "Adding…";
        fetch("/cart/add.js", { method:"POST", headers:{ "Content-Type":"application/x-www-form-urlencoded" },
          body: new URLSearchParams(new FormData(form)) })
          .then(function(r){ return r.json(); })
          .then(function(){ return fetch("/cart.js"); })
          .then(function(r){ return r.json(); })
          .then(function(cart){
            counts.forEach(function(c){ c.textContent = "(" + cart.item_count + ")"; });
            if(window.gtag){ window.gtag("event", "add_to_cart", { currency: "CAD", items: [{ item_id: vid }] }); }
            btn.textContent = "Added ✓";
            setTimeout(function(){ btn.textContent = label; }, 1600);
          })
          .catch(function(){ window.location.href = "/cart"; });
      });
    });
  }

  /* ---------- boot ---------- */
  function boot(){
    initReveals(); initHeader(); initHero(); initVideo();
    initRibbon(); initCollections(); initDrawer(); initCart();
    document.documentElement.classList.add("olfyn-ready");
  }
  if(document.readyState !== "loading") boot();
  else document.addEventListener("DOMContentLoaded", boot);
})();
